var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('b-sidebar',{attrs:{"id":"sidebar-right","title":_vm.title,"right":"","shadow":""}},[_c('div',{staticClass:"px-6 py-6"},[_c(_vm.view,{tag:"component"})],1)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }